import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { useMutation } from "@tanstack/react-query";

const updateMMobileLocators = async ({data, testCaseId, teststepid}) => {
      const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateFindAndAssign&companyid=${user.companyid}&token=${user.token}&testCaseId=${testCaseId}&teststepid=${teststepid}`,
   {
    android_uiautomator: data.android_uiautomator,
    id_strategy: data.id_strategy,
    xpath: data.xpath
   },
  );
  return response.data;
}


const useUpdateMobileLocators = (options) => {
    return useMutation({
        mutationFn: updateMMobileLocators,
        ...options,
    })
}
export default useUpdateMobileLocators;